import React, {Component} from 'react';
import API from "../../services/API";
import {NavLink} from "react-router-dom";
import EmptyPic from "../../assets/images/emptypic.png"
import Menu from "../../assets/images/menu.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt, faUserEdit} from "@fortawesome/free-solid-svg-icons";


class TopMenu extends Component {
    state = {
        user: []
    }
    onToggleMenu = () => {
        //.main-nav
        var x = document.getElementsByClassName("main-nav")[0];
        if (window.getComputedStyle(x).display === "none") {
            x.style.display="block";
        }
        else  {
            x.style.display="none";
        }
    }
    onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace('/')
    }
    render() {
        let avatar_length = 0;
        if(typeof this.state.user.avatar !== 'undefined'){
            const avatar = this.state.user.avatar;
            avatar_length = avatar.length;
        }

        return (
            <React.Fragment>
                <section className="container-fluid top-menu rtl p-0 mobile-blue-bg">
                    <div className="menu-icon float-right m-2 pointer ">
                        <img src={Menu} alt="Menu" width={24} onClick={this.onToggleMenu} className='mobile-show'/>
                    </div>
                    <div className="w-75 float-left ">
                     {/*   <NavLink className=" nav-link " to="/profile" title='مشاهده و ویرایش اطلاعات پروفایل کاربری'>


                        </NavLink>*/}
                        <div className="dropdown">
                            <button className="dropdown-toggle border-0 bg-transparent" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                                    <ul className='float-right'>
                                        <li>
                                            <img src={ avatar_length ? this.state.user.avatar : EmptyPic} width={25} className='rounded-circle' alt="Avatar"/>
                                        </li>
                                        <li>
                                            {this.state.user.first_name} {this.state.user.last_name}
                                        </li>
                                    </ul>

                            </button>
                            <div className="dropdown-menu text-center super-small" aria-labelledby="dropdownMenuButton">
                                <NavLink className=" dropdown-item " to="/profile" title='مشاهده و ویرایش اطلاعات پروفایل کاربری' >
                                    <FontAwesomeIcon icon={faUserEdit} className=' text-dark mx-2'/>
                                    مشاهده پروفایل
                                </NavLink>
                                <button onClick={this.onExitClick} className="mt-2 btn dropdown-item">
                                    <FontAwesomeIcon icon={faSignOutAlt} className=' text-danger'/>
                                    &nbsp;
                                    خروج ار حساب کاربری
                                </button>
                            </div>
                        </div>
                    </div>

                </section>
            </React.Fragment>


        );
    }

    componentDidMount = () => {
        API.index()
            .then((response) => {
                const user_group = response.results.user_groups[0].id; //8 for staff & 7 for manager
                window.localStorage.setItem("currency_unit", response.results.currency_unit.symbol);
                const user = response.results.user;
                this.setState({user , user_group});
            })
    }
}

export default TopMenu;